import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { AllRestrictionsReceivedRecord, ProposedRegulationReceived } from "../types";

export const GET_REGULATION_TEMPLATES = "GET_REGULATION_TEMPLATES";
export const REGULATION_TEMPLATES_RECEIVED = "REGULATION_TEMPLATES_RECEIVED";
export const POST_REGULATION_TEMPLATES = "POST_REGULATION_TEMPLATES";
export const DELETE_REGULATION_TEMPLATES = "DELETE_REGULATION_TEMPLATES";
export const SET_TEMPLATES_RESTRICTIONS_DATA = "SET_TEMPLATES_RESTRICTIONS_DATA";
export const SET_TEMPLATES_REGULATION_DATA = "SET_TEMPLATES_REGULATION_DATA";

export interface TypeOfTemplatesRegulation extends ProposedRegulationReceived {}

export type getParams =
    | {
          fields: string;
      }
    | {};

export interface RegulationTemplates {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: {
        name: string;
        id: number;
        data: {
            payment: {
                fees: string[];
                duration: number[];
            };
            time_limit: number;
            restrictions: AllRestrictionsReceivedRecord[];
            sub_activity_id: number;
            effective_dates_period: string;
        };
        template_type: string;
    }[];
}

export interface RegulationTemplatesReceivedAction {
    type: typeof REGULATION_TEMPLATES_RECEIVED;
    payload: { data: RegulationTemplates };
}

export interface GetRegulationTemplatesAction {
    type: typeof GET_REGULATION_TEMPLATES;
    payload: { params: getParams };
}

export interface DeleteRegulationTemplatesAction {
    type: typeof DELETE_REGULATION_TEMPLATES;
    payload: { id: number };
}

export interface PostRegulationTemplatesAction {
    type: typeof POST_REGULATION_TEMPLATES;
    payload: {
        data: {
            [props: string]: object | null | number | string | boolean | undefined;
        };
    };
}

export interface SetTemplatesRestrictionsDataAction {
    type: typeof SET_TEMPLATES_RESTRICTIONS_DATA;
    payload: { data: AllRestrictionsReceivedRecord[] };
}

export interface SetTemplatesRegulationDataAction {
    type: typeof SET_TEMPLATES_REGULATION_DATA;
    payload: { data: TypeOfTemplatesRegulation };
}

export type RegulationTemplatesTypes =
    | RegulationTemplatesReceivedAction
    | GetRegulationTemplatesAction
    | DeleteRegulationTemplatesAction
    | PostRegulationTemplatesAction
    | SetTemplatesRestrictionsDataAction
    | SetTemplatesRegulationDataAction
    | ResetStateAction;

export interface RegulationTemplatesState {
    templates: RegulationTemplates;
    templatesRestrictionsData: AllRestrictionsReceivedRecord[];
    templatesRegulationData: TypeOfTemplatesRegulation;
}
